import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { useNavigateToAssetOverview } from '@terminal/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { PriceChange } from '@terminal/modules/impacted-companies/components/PriceChange';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import {
  POSTHOG_TRACKING_SOURCES,
  PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';
import { useTranslation } from 'react-i18next';
import { CatalystBadge } from '../catalyst-badge/CatalystBadge';

export type CompanyCatalystBadgeProps = {
  entityTag?: string;
  source?: PosthogTrackingSource;
};

export const CompanyCatalystBadge = ({
  entityTag,
  source = POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER,
}: CompanyCatalystBadgeProps) => {
  const { data: entityData } = useEntity(entityTag);
  const entity = entityData?.data;
  const { t } = useTranslation(['widget']);

  const { navigateToAssetOverview } = useNavigateToAssetOverview();

  if (!entity) {
    return null;
  }

  return (
    <CatalystBadge
      tooltipLabel={t('widget:assetOverview.openAssetOverview')}
      logo={<AssetLogoContainer entity={entity} size={16} />}
      name={entity.name}
      trailing={<PriceChange entity={entity} />}
      onClick={() => navigateToAssetOverview(entity.tag, source)}
    />
  );
};
